import hoc, { IconProps } from 'bloko/blocks/icon/hoc';

const CompanysLifeScaleSmallKindDefault = hoc(
    (props: IconProps) => (
        <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g>
                <path
                    d="M15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5C12.1421 0.5 15.5 3.85786 15.5 8Z"
                    stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.1778 10.5334H7.75551L5.79993 12V10.5334H4.82215C4.55214 10.5334 4.33325 10.3145 4.33325 10.0445V5.15552C4.33325 4.88551 4.55214 4.66663 4.82215 4.66663H11.1778C11.4478 4.66663 11.6667 4.88551 11.6667 5.15552V10.0445C11.6667 10.3145 11.4478 10.5334 11.1778 10.5334Z"
                    stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7.22853 6.78518C7.10606 6.53588 6.85247 6.37793 6.57471 6.37793C6.29696 6.37793 6.04337 6.53588 5.9209 6.78518"
                    stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10.1599 6.78518C10.0375 6.53588 9.78387 6.37793 9.50611 6.37793C9.22835 6.37793 8.97477 6.53588 8.85229 6.78518"
                    stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.77844 8.57788C7.49348 9.22981 8.5874 9.22981 9.30244 8.57788"
                    stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </svg>
    ),
    'Companys'
);
export default CompanysLifeScaleSmallKindDefault;
